import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Form, notification, Space } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { MenuProps } from 'antd/lib/menu';
import Cookies from 'js-cookie';
import { localize } from 'mixins/helpers';
import React, { FC, useState } from 'react';
import { EventSection, EventType, logFunction } from '../../services/logs';
import { resetPassword } from './actions';
import HistoryModal from './components/history-modal';
import './language-switcher.scss';
import { LanguageSwitcherProps } from './language-switcher.type';
import ResetPassModal from '/react4xp/parts/language-switcher/components/reset-pass-modal';
import ApiTokenModal from './components/api-token-modal';

const UserDropdown: FC<LanguageSwitcherProps> = (props: LanguageSwitcherProps) => {
    const [openChangePass, setOpenChangePass] = useState(false);
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openApiTokenModal, setOpenApiTokenModal] = useState(false);

    const [form] = Form.useForm();

    const items: MenuItemType[] = [
        {
            label: 'API-токен',
            key: 'apiToken',
        },
        {
            label: localize('change-password', props.translations),
            key: 'changePassword',
        },
        {
            label: localize('login-history', props.translations),
            key: 'history',
        },
        {
            label: localize('exit', props.translations),
            key: 'exit',
        },
    ];

    if (props.membership && props.membership.length > 0) {
        items.unshift({
            label: <span>{localize('admin-panel', props.translations)}</span>,
            key: 'admin',
            className: 'hide-on-mobile',
        });
    }

    const closeHistory = () => {
        setOpenHistoryModal(false);
    };

    const closeResetPass = () => {
        setOpenChangePass(false);
        form.resetFields();
    };

    const logout = () => {
        logFunction({
            config: {
                section: EventSection.ADM_ACTIONS,
                type: EventType.LOGOUT,
                description: localize('exit-from-system', props.translations),
            },
            wrapperFunction() {
                return new Promise(() => {
                    Cookies.remove('token');
                    Cookies.remove('refresh_token');
                    open('/site/ru/master/isna-portal-cms/_/idprovider/jwt/logout', '_self');
                });
            },
        });
    };

    const handleResetPass = () => {
        form.validateFields().then(() => {
            const { oldPassword, newPassword } = form.getFieldsValue();

            if (newPassword !== oldPassword) {
                setIsLoading(true);

                resetPassword(
                    {
                        currentPassword: oldPassword,
                        newPassword,
                    },
                    props.token
                )
                    .then(() => {
                        closeResetPass();

                        logout();

                        notification['success']({
                            message: localize(
                                'block-auth-password-successfully-reset',
                                props.translations
                            ),
                            description: localize(
                                'block-auth-please-try-logging',
                                props.translations
                            ),
                        });
                    })
                    .finally(() => setIsLoading(false));
            } else {
                notification['warning']({
                    message: localize('attention', props.translations),
                    description: localize('new-password-same', props.translations),
                });
            }
        });
    };

    const onClick: MenuProps['onClick'] = ({ key }) => {
        switch (key) {
            case 'admin':
                open('/arm', '_self');
                break;
            case 'changePassword':
                setOpenChangePass(true);
                break;
            case 'history':
                setOpenHistoryModal(true);
                break;
            case 'apiToken':
                setOpenApiTokenModal(true);
                break;
            case 'exit':
                logout();
                break;
        }
    };

    return (
        <>
            <Dropdown
                menu={{ items, onClick }}
                className="language-switcher"
                trigger={['click']}
            >
                <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        {props.user.displayName}
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            <ResetPassModal
                open={openChangePass}
                close={closeResetPass}
                onOk={handleResetPass}
                form={form}
                isRestoring={isLoading}
                translations={props.translations}
            />
            <ApiTokenModal
                open={openApiTokenModal}
                close={() => setOpenApiTokenModal(false)}
                accessToken={props.token}
                translations={props.translations}
            />
            <HistoryModal
                open={openHistoryModal}
                close={closeHistory}
                translations={props.translations}
                user={props.user}
            />
        </>
    );
};

export default UserDropdown;
